import { render } from "./Privacy.vue?vue&type=template&id=5e296432&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=5e296432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e296432"]])

export default __exports__